import { palette } from "../palette";

export default {
    styleOverrides: {
        root: {
          lineHeight: '22px',
          color: palette.disabled.dark,
          '&.Mui-disabled': {
            color: palette.disabled.contrastText,
          },
        },
      },
};